"use client";
import React, { useState } from 'react';

const MarketInsightFaq = ({ faqs }) => {
    const [openFaq, setOpenFaq] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };
    return (
        <section className="faq-section-mi">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="faq-title-mi">Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-list-mi">
                {faqs.map((faq, index) => (
                  <div key={index} className="faq-item-mi">
                    <button
                      className={`faq-question-mi ${openFaq === index ? 'active-mi' : ''}`}
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon-mi">
                        {openFaq === index ? '−' : '+'}
                      </span>
                    </button>
                    {openFaq === index && (
                      <div className="faq-answer-mi">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default MarketInsightFaq;